require("./jw-preroll");

import scrollama from "scrollama";

        var scroll = d3.select("#g-scroll");
        var figure = scroll.select("figure");
        var article = scroll.select("article");
        var step = article.selectAll(".step");
        var photos = figure.selectAll(".g-asset");

        
        // initialize the scrollama
        var scroller = scrollama();
        

        // generic window resize listener event
        function handleResize() {
            // 1. update height of step elements
            var stepH = Math.floor(window.innerHeight * 1.25);
            step.style("height", stepH + "px");

            var figureHeight = window.innerHeight / 2;
            var figureMarginTop = (window.innerHeight - figureHeight) / 12;

            figure
                .style("height", figureHeight + "px")
                .style("top", figureMarginTop + "px");

            // 3. tell scrollama to update new element dimensions
            scroller.resize();
        }

        // scrollama event handlers
        function handleStepEnter(response) {
                // response = { element, direction, index }

            // add color to current step only
            step.classed("is-active", function (d, i) {
                return i === response.index;
            })

            // update graphic based on step
            photos.classed("entered", function (d, i) {
                return i === response.index;
            }
            );
            
        }

        function init() {

            // 1. force a resize on load to ensure proper dimensions are sent to scrollama
            handleResize();

            // 2. setup the scroller passing options
            //      this will also initialize trigger observations
            // 3. bind scrollama event handlers (this can be chained like below)
            scroller
                .setup({
                    step: "#g-scroll article .step",
                    offset: 0.9,
                    debug: false
                })
                .onStepEnter(handleStepEnter);
                
            }

        // kick things off
        init();






//added sidechain 
import Sidechain from '@nprapps/sidechain';
const guest = Sidechain.registerGuest({ sentinel: 'st' });

guest.sendMessage({
        type: 'analytics',
        eventCategory: 'interaction',
        eventAction: 'click',
        eventLabel: 'etc'
    })
    //end sidechain

